import { ReactComponent as Portaldot } from "../../../components/icons/portaldot.svg";

const portaldot = {
  name: "Portaldot",
  icon: <Portaldot />,
  identity: "portaldot",
  sub: "portaldot",
  value: "portaldot",
  chain: "portaldot",
  symbol: "POT",
  decimals: 14,
  chainIcon: "originalPolkadot",
  color: "#008c4d",
  colorSecondary: "rgba(230, 0, 122, 0.1)",
  buttonColor: "#008c4d",
  logo: "logo-img-2",
  modules: {
    assets: false,
    identity: false,
    multisig: false,
    vestings: false,
    proxy: false,
  },
  nodes: [
    { name: "Node1", url: "wss://mainnet.portaldot.io/" },
  ],
  useOnChainBlockData: false,
};

export default portaldot;